




















































import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import MessageDto from '@/models/Messages/MessageDto';
import EntityType from '@/models/Shared/EntityType';
import { AppModule } from '@/store/modules/app';
import ConversationParticipantDto from '@/models/Conversations/ConversationParticipantDto';


@Component({
  name: 'MessagBody',
})
export default class extends GiganautVue {

    EntityType = EntityType;
    value = new Date();

	@Prop({required: true})
	message: MessageDto;

    @Prop({required: true})
	participant: ConversationParticipantDto;

    get agencyName() {
        return AppModule.currentAgencyContext.brandName;
    }

    getUserAvatarUrl(message: MessageDto) {
    return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/" + this.participant.entityType.toString() + "/" + this.participant.entityId + "/resized-100/" + this.participant.avatar;
  }
}
